import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { PayoutService } from 'src/app/services/payout.service';
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import * as uuid from 'uuid';
import { lowerCase, upperCase } from 'lodash';

const swal = require('sweetalert');
@Component({
  selector: 'app-add-beneficiaries',
  templateUrl: './add-beneficiaries.component.html',
  styleUrls: ['./add-beneficiaries.component.scss']
})
export class AddBeneficiariesComponent implements OnInit {
  PCountry: any;
  PState: any;
  Paddress: any;
  Pcity: any;
  stateList: any;
  //   public stateList: Array<string> = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chandigarh',
  //   'Chhattisgarh', 'Dadra and Nagar Haveli', 'Daman and Diu', 'Delhi', 'Goa',
  //   'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir', 'Jharkhand', 'Karnataka', 'Kerala', 'Lakshadweep', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Orissa', 'Puducherry', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana',
  //   'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
  // ];
  ifsccodedetails: boolean = true;
  updateifsccodedetails: boolean = true;
  ifsccodedetail: boolean = false;
  updateifsccodedetail: boolean = false;
  isimgHidden: boolean;
  IfscZipCode: any;
  IfscCity: any;
  IfscAddress: any;
  IfscState: any;
  //Address= new FormControl("", []);
  City = new FormControl("", [Validators.maxLength(20), Validators.minLength(1), Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  State = new FormControl("", [Validators.maxLength(20), Validators.minLength(1)]);
  ZipCode = new FormControl("", [Validators.pattern("^(?!000000)[0-9]{6}$")]);
  IfscBankName: any;
  IfscBranchName: any;
  Bankdetailserrormessage: boolean = false;
  EditBankdetailserrormessage: boolean = false;
  BeneficiaryKeyId: any;
  upitxt: boolean = false;
  public PayOutAccountList: Array<string> = ['Bank Account'];
  public CountryList: Array<string> = ['India'];
  Editaccerrormessage: boolean = false;
  AccountNo: any;
  accerrormessage: boolean = false;

  Status: any;
  isReadytoUpdateInfo: boolean = false;
  benId: any;
  rows: any;
  Editbeneficiarie: boolean = false;
  Addbeneficiarie: boolean = false;
  ifsccodedetailsshow: boolean = false;
  updateifsccodedetailsshow: boolean = false;
  viewid: any;
  Editid: any;
  public Type: Array<string> = ['RoutingTransitNumber', 'BankSortCodes', 'BsbNumbers', 'SwiftCode', 'MicrCode', 'IfscCode'];
  public AccountType: Array<string> = ['SalaryAccount', 'CurrentAccount', 'SavingAccount', 'RecurringDeposits', 'FixedDeposits'];

  BeneficiaryName = new FormControl("", [Validators.required, Validators.pattern("^(?! )[0-9a-zA-Zs ]*$")]);




  BenPayOutBeneficiaryKeyId = new FormControl("", [Validators.required]);
  BenPayoutCustomerkeyId = new FormControl("", []);
  BenBankCodeType = new FormControl("", [Validators.required]);
  BenBankName = new FormControl("", [Validators.required, Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  BenAddress = new FormControl("", [Validators.required]);
  BenBranchName = new FormControl("", [Validators.required]);
  BenBankCode = new FormControl("", [Validators.required, , Validators.pattern('^(?!0 )[A-Z]{4}0(?!000000)[A-Z0-9]{6}$')]);
  BenAccountNumber = new FormControl("", [Validators.required,
  Validators.maxLength(18),
  Validators.minLength(9),
  Validators.pattern("^(?! )(?!0000000)[a-zA-Z0-9]{9,18}$")]);

  //  Validators.pattern("^(?!00000)[a-zA-Z0-9]{9,17}$")]);

  BenBankAccountType = new FormControl("", [Validators.required]);
  BenBankCountry = new FormControl("", []);
  BenVerificationStatus = new FormControl("", []);
  BenVerificationResponse = new FormControl("", []);
  BenUpiVpa = new FormControl("", []);
  BenPreferPayOutAccount = new FormControl("", []);
  BenBeneficiaryName = new FormControl("", [Validators.required, Validators.pattern("^(?! )[0-9a-zA-Zs ]*$")]);


  PayOutBeneficiaryKeyId = new FormControl("", [Validators.required]);
  PayoutCustomerkeyId = new FormControl("", []);
  BankCodeType = new FormControl("", [Validators.required]);
  BankName = new FormControl("", [Validators.required, Validators.pattern("^(?! )[a-zA-Zs ]*$")]);

  BranchName = new FormControl("", [Validators.required]);
  BankCode = new FormControl("", [Validators.required, Validators.pattern('^(?!0 )[A-Z]{4}0(?!000000)[A-Z0-9]{6}$')]);

  editConfirmAccountNumber = new FormControl("", [Validators.required,
  Validators.maxLength(18),
  Validators.minLength(9),
  Validators.pattern("^(?! )(?!0000000)[a-zA-Z0-9]{9,18}$")]);
  //  Validators.pattern("^(?!00000)[0-9]{9,17}$")]);
  AccountNumber = new FormControl("", [Validators.required,
  Validators.maxLength(18),
  Validators.minLength(9),
  Validators.pattern("^(?! )(?!0000000)[a-zA-Z0-9]{9,18}$")]);
  //  Validators.pattern("^(?!00000)[0-9]{9,17}$")]);


  ConfirmAccountNumber = new FormControl("", [Validators.required,
  Validators.maxLength(18),
  Validators.minLength(9),
  Validators.pattern("^(?! )(?!0000000)[a-zA-Z0-9]{9,18}$")]);
  //  Validators.pattern("^(?!00000)[0-9]{9,17}$")]);
  BankAccountType = new FormControl("", [Validators.required]);
  BankCountry = new FormControl("", []);
  VerificationStatus = new FormControl("", []);
  VerificationResponse = new FormControl("", []);
  UpiVpa = new FormControl("", []);
  PreferPayOutAccount = new FormControl("", []);
  UpdatedUserName = new FormControl("", []);
  PCustomerkeyId: any;
  constructor(private router: Router, private service: PayoutService, private commonfunction: CommonFunctionService, private route: ActivatedRoute) {

    this.stateList = this.commonfunction.getStatesList();
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
      this.Editid = params['EditId'];
      if (this.viewid != null || this.viewid != undefined) {
        this.Addbeneficiarie = true;
        this.Editbeneficiarie = false
      }
      else {
        let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
        this.service.ViewBeneficiarieDetails(this.Editid, merchantdata.MerchantKeyId).subscribe(result => {
          this.rows = result;
          // this.IfscCity=result.City;
          //this.IfscAddress=result.Address;
          this.IfscState = result.State


          this.AccountNo = result.AccountNumber;
          this.Status = result.Status;
          this.PCustomerkeyId = result.PayoutCustomerkeyId;
          this.BeneficiaryKeyId = result.PayOutBeneficiaryKeyId
          this.benId = result.Id;
          if (this.rows.BankAccountType == 0) {
            this.rows.BankAccountType = "SalaryAccount"
          }
          else if (this.rows.BankAccountType == 1) {
            this.rows.BankAccountType = "CurrentAccount"
          }
          else if (this.rows.BankAccountType == 2) {
            this.rows.BankAccountType = "SavingAccount"
          }
          else if (this.rows.BankAccountType == 3) {
            this.rows.BankAccountType = "RecurringDeposits"
          }
          else if (this.rows.BankAccountType == 4) {
            this.rows.BankAccountType = "FixedDeposits"
          }
          if (this.rows.BankCodeType == 0) {
            this.rows.BankCodeType = "RoutingTransitNumber"
          }
          else if (this.rows.BankCodeType == 1) {
            this.rows.BankCodeType = "BankSortCodes"
          }
          else if (this.rows.BankCodeType == 2) {
            this.rows.BankCodeType = "BsbNumbers"
          }
          else if (this.rows.BankCodeType == 3) {
            this.rows.BankCodeType = "SwiftCode"
          }
          else if (this.rows.BankCodeType == 4) {
            this.rows.BankCodeType = "MicrCode"
          }
          else if (this.rows.BankCodeType == 5) {
            this.rows.BankCodeType = "IfscCode"
          }

        });

        this.Addbeneficiarie = false;
        this.Editbeneficiarie = true;
      }
    });
  }

  ngOnInit() {
  }
  NewBeneficiarie() {
    let form = {

      MerchantKeyId: 0,
      PayOutBeneficiaryKeyId: "",
      PayoutCustomerkeyId: "",
      BankCodeType: "",
      BankName: "",
      BranchName: "",
      BankCode: "",
      AccountNumber: "",
      BankAccountType: "",
      BankCountry: "",
      VerificationStatus: "",
      VerificationResponse: "",
      UpiVpa: "",
      PreferPayOutAccount: "",
      UpdatedUserName: "",
      BeneficiaryName: "",
      Address: "",
      City: "",
      State: "",
      ZipCode: "",
      LoginUserId: ''

    };
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.UpdatedUserName = this.commonfunction.getUserId();
    form.MerchantKeyId = merchantdata.MerchantKeyId;

    //   const myId = uuid.v4();
    //   var uniqueid=myId.substring(0,5);
    //  form.PayOutBeneficiaryKeyId=  "M"+ merchantdata.MerchantKeyId+"B" +uniqueid;
    // form.Address=this.IfscAddress;

    //form.City=this.IfscCity;
    // form.State=this.IfscState;
    //form.ZipCode=this.ZipCode.value;
    //form.ZipCode=this.IfscZipCode;
    form.PayoutCustomerkeyId = this.viewid;
    form.BankCodeType = this.BankCodeType.value;
    // form.BankName=this.IfscBankName;
    form.BankName = this.BankName.value;
    form.BranchName = this.BranchName.value;
    // form.BranchName=this.IfscBranchName;
    form.BankCode = this.BankCode.value;
    form.AccountNumber = this.AccountNumber.value;
    form.BankAccountType = this.BankAccountType.value;
    //form.BankCountry= this.BankCountry.value;  
    form.VerificationStatus = this.VerificationStatus.value;
    form.VerificationResponse = this.VerificationResponse.value;
    form.UpiVpa = this.UpiVpa.value;
    form.PreferPayOutAccount = this.PreferPayOutAccount.value;
    form.BeneficiaryName = this.BeneficiaryName.value;
    form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
    this.service.newBeneficiarie(form).subscribe(result => {


      if (result != null) {
        if (result.VerificationStatus == "Failed") {
          this.openConfirmationDialog();
        }
        else {
          swal("Added", "Beneficiary Created Successfully", "success");
          this.router.navigate(["PayOut/BeneficiaryList"]);
        }
      }
    });

  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
     if (charCode > 31 && (charCode < 48 || charCode > 57)) {
     return false;
     }
     return true;
      }
  openConfirmationDialog() {

    swal({

      title: 'Virtual Account is not setup, Contact to FastSwiff',
      icon: 'warning',
      buttons: {
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: "bg-primary",
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
        window.location.reload();
      }
    });
  }
  checkaccnumbers() {
    var Eacc = this.BenAccountNumber.value;
    var Ecacc = this.editConfirmAccountNumber.value;
    if (Eacc == "" || Ecacc == "") {
      this.Editaccerrormessage = false;
    }
    else {
      if (Eacc != Ecacc) {
        this.Editaccerrormessage = true;
      }
      else {
        this.Editaccerrormessage = false;
      }

    }
  }

  checkaccnumber() {
    var acc = this.AccountNumber.value;
    var cacc = this.ConfirmAccountNumber.value;
    if (acc == "" || cacc == "") {
      this.accerrormessage = false;
    }
    else {
      if (acc != cacc) {
        this.accerrormessage = true;
      }
      else {
        this.accerrormessage = false;
      }

    }
  }

  EditBeneficiarie() {
    let form = {

      MerchantKeyId: 0,
      PayOutBeneficiaryKeyId: "",
      PayoutCustomerkeyId: "",
      BankCodeType: "",
      BankName: "",
      BranchName: "",
      BankCode: "",
      AccountNumber: "",
      BankAccountType: "",
      BankCountry: "",
      VerificationStatus: "",
      VerificationResponse: "",
      UpiVpa: "",
      PreferPayOutAccount: "",
      UpdatedUserName: "",
      Id: 0,
      BeneficiaryName: "",
      Status: "",
      Address: "",
      City: "",
      State: "",
      ZipCode: "",
      LoginUserId:''

    };
    form.Address = this.BenAddress.value
    form.City = this.City.value;
    form.State = this.State.value;
    form.ZipCode = this.ZipCode.value;
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.UpdatedUserName = this.commonfunction.getUserId();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
    form.PayOutBeneficiaryKeyId = this.BeneficiaryKeyId;
    form.PayoutCustomerkeyId = this.PCustomerkeyId;
    form.BankCodeType = this.BenBankCodeType.value;
    form.BankName = this.BenBankName.value;
    form.BranchName = this.BenBranchName.value;
    form.BankCode = this.BenBankCode.value;
    form.AccountNumber = this.BenAccountNumber.value;
    form.BankAccountType = this.BenBankAccountType.value;
    form.BankCountry = this.BenBankCountry.value;
    form.VerificationStatus = this.BenVerificationStatus.value;
    form.VerificationResponse = this.BenVerificationResponse.value;
    form.UpiVpa = this.BenUpiVpa.value;
    form.PreferPayOutAccount = this.BenPreferPayOutAccount.value;
    form.BeneficiaryName = this.BenBeneficiaryName.value;
    form.Status = this.Status;
    form.Id = this.benId;
    form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
    this.service.updateBeneficiarie(form).subscribe(result => {

      if (result != null) {

        swal("Update", "Beneficiary Updated  Successfully", "success");
        this.router.navigate(["PayOut/BeneficiaryList"]);
      }
    });

  }


  AccountTypeChange() {
    var type = this.PreferPayOutAccount.value;
    if (type == "Upi") {
      this.upitxt = true;
    }
    else {
      this.upitxt = false;
    }
  }
  EditAccountTypeChange() {
    var type = this.BenPreferPayOutAccount.value;
    if (type == "Upi") {
      this.upitxt = true;
    }
    else {
      this.upitxt = false;
    }
  }



  onKey() {
    this.isReadytoUpdateInfo = true;
  }
  PayOutBeneficiaryKeyIderrors() {
    return this.PayOutBeneficiaryKeyId.hasError("required")
      ? "PayOut Beneficiary KeyId is required"
      : "";
  }
  BankCodeTypeerrors() {
    return this.BankCode.hasError("required")
      ? "Bank Code/IFSC Code is required"
      : this.BankCode.hasError('pattern')
        ? 'Bank Code/IFSC Code format should be like eg:AAAA0000001'
        : '';


  }

  BankCodeTypeerrorss() {
    return this.BenBankCode.hasError("required")
      ? "Bank Code/IFSC Code is required"
      : this.BenBankCode.hasError('pattern')
        ? 'Bank Code/IFSC Code format should be like eg:AAAA0000001'
        : '';


  }
  BenBankCodeTypeerrors() {
    return this.BenBankCodeType.hasError("required")
      ? "Bank Code/IFSC Code is required"
      : this.BenBankCodeType.hasError('pattern')
        ? 'Bank Code/IFSC Code format should be like eg:AAAA0000001'
        : '';
  }
  BankNameerrors() {
    return this.BankName.hasError("required")
      ? "BankName is required"
      : this.BankName.hasError("pattern") ? "BankName should allow only alphabets" : "";
  }
  Accountnumbererrors() {
    return this.AccountNumber.hasError("required")
      ? "Account Number is required"
      : this.AccountNumber.hasError("pattern")
        ? "Enter Valid Account number. It allows only 9 to 18 digits"
        : "";
  }


  BenAccountnumbererrors() {
    return this.BenAccountNumber.hasError("required")
      ? "ConfirmAccount Number is required"
      : this.BenAccountNumber.hasError("pattern")
        ? "Enter valid Account Number. it allows only 9 to 18 digits"
        : "";
  }



  AccConfirmAccountnumbererrors() {
    return this.ConfirmAccountNumber.hasError("required")
      ? "ConfirmAccount Number is required"
      : this.ConfirmAccountNumber.hasError("pattern")
        ? "Enter valid Confirm Account Number. it allows only 9 to 17 digits"
        : "";
  }

  ConfirmAccountnumbererrors() {
    return this.editConfirmAccountNumber.hasError("required")
      ? "ConfirmAccount Number is required"
      : this.editConfirmAccountNumber.hasError("pattern")
        ? "Enter valid Confirm Account Number. it allows only 9 to 17 digits"
        : "";
  }
  BranchNameerrors() {
    return this.BranchName.hasError("required")
      ? "Branch Name is required"
      : "";
  }
  BankAccountTypeerrors() {
    return this.BankAccountType.hasError("required")
      ? "BankAccount Type is required"
      : "";
  }
  BankCountryerrors() {
    return this.BankCountry.hasError("required")
      ? "Bank Country is required"
      : "";
  }
  VerificationStatuserrors() {
    return this.VerificationStatus.hasError("required")
      ? "Verification Status is required"
      : "";
  }
  VerificationResponseerrors() {
    return this.VerificationResponse.hasError("required")
      ? "Verification Response is required"
      : "";
  }

  BeneficiaryNameerrors() {
    return this.BeneficiaryName.hasError("required")
      ? "BeneficiaryName is required"
      : this.BeneficiaryName.hasError("pattern") ? "BeneficiaryName should allow only alphanumerics" : "";

  }


  BenBeneficiaryNameerrors() {
    return this.BenBeneficiaryName.hasError("required")
      ? "BeneficiaryName is required"
      : this.BenBeneficiaryName.hasError("pattern") ? "BeneficiaryName should allow only alphabets" : "";

  }

  BenBankNameerrors() {
    return this.BenBankName.hasError("required")
      ? "BankName is required"
      : this.BenBankName.hasError("pattern") ? "BankName should allow only alphabets" : "";
  }
  Addresserrors() {
    return this.BenAddress.hasError("required")
      ? "Address is required"
      : "";
  }

  Cityerrors() {
    return this.City.hasError("pattern") ? "City should allow only alphabets" : "";

  }

  Stateerrors() {
    return this.State.hasError("pattern") ? "State should allow only alphabets" : "";

  }
  ZipCodeerrors() {
    return this.ZipCode.hasError("pattern") ? "Zip Code  should be 6 digit number only" : "";

  }
  // PreferPayOutAccounterrors()
  // {
  //   return this.VerificationStatus.hasError("required")
  //   ? "VerificationStatus is required"
  //     : "";
  // }
  EditCheckAccNumAndIfsccode() {
    if (this.BenAccountNumber.value != "" && this.BenAccountNumber.value != "") {
      let form = {

        MerchantKeyId: 0,
        PayOutBeneficiaryKeyId: "",
        PayoutCustomerkeyId: "",
        BankCodeType: "",
        BankName: "",
        BranchName: "",
        BankCode: "",
        AccountNumber: "",
        BankAccountType: "",
        BankCountry: "",
        VerificationStatus: "",
        VerificationResponse: "",
        UpiVpa: "",
        PreferPayOutAccount: "",
        UpdatedUserName: "",
        Id: 0,
        BeneficiaryName: "",
        Status: "",

      };
      let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
      form.UpdatedUserName = this.commonfunction.getUserId();
      form.MerchantKeyId = merchantdata.MerchantKeyId;
      form.PayoutCustomerkeyId = this.PCustomerkeyId;
      form.BankCode = this.BenBankCode.value;
      form.AccountNumber = this.BenAccountNumber.value;
      this.service.GetBeneficiarieBankDetails(form).subscribe(result => {

        if (result != null) {
          if (result == true) {
            this.EditBankdetailserrormessage = true;
          }
          else {
            this.EditBankdetailserrormessage = false;
          }
        }
      });
    }
  }


  CheckAccNumAndIfsccode() {
    //this.GetIfsccodedetails()

    if (this.AccountNumber.value != "" && this.BankCode.value != "") {
      let form = {

        MerchantKeyId: 0,
        PayOutBeneficiaryKeyId: "",
        PayoutCustomerkeyId: "",
        BankCodeType: "",
        BankName: "",
        BranchName: "",
        BankCode: "",
        AccountNumber: "",
        BankAccountType: "",
        BankCountry: "",
        VerificationStatus: "",
        VerificationResponse: "",
        UpiVpa: "",
        PreferPayOutAccount: "",
        UpdatedUserName: "",
        Id: 0,
        BeneficiaryName: "",
        Status: "",

      };
      let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
      form.UpdatedUserName = this.commonfunction.getUserId();
      form.MerchantKeyId = merchantdata.MerchantKeyId;
      form.PayoutCustomerkeyId = this.viewid;
      form.BankCode = this.BankCode.value;
      form.AccountNumber = this.AccountNumber.value;
      this.service.GetBeneficiarieBankDetails(form).subscribe(result => {

        if (result != null) {
          if (result == true) {
            this.Bankdetailserrormessage = true;
          }
          else {
            this.Bankdetailserrormessage = false;
          }
        }
      });
    }
  }

  GetIfsccodedetails() {
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.GetIfsccodedetails(this.BankCode.value, merchantdata.MerchantKeyId).subscribe(result => {
      if (result != null) {
        this.ifsccodedetails = false;
        this.ifsccodedetailsshow = true;
        this.ifsccodedetail = false;

        this.IfscBankName = result.BankName;
        this.IfscBranchName = result.BranchName;
        this.IfscZipCode = result.ZipCode;
        this.IfscCity = result.City;
        this.IfscAddress = result.Address;
        this.IfscState = result.State;
        var ifsc = result.State.toLowerCase().split(' ');
        for (var i = 0; i < ifsc.length; i++) {
          ifsc[i] = ifsc[i].charAt(0).toUpperCase() + ifsc[i].substring(1);
        }
        this.IfscState = ifsc.join(' ');
        //  var ifsc=this.IfscState.toLowerCase();
        //  this.IfscState=ifsc.split(" ");
        //   this.IfscState=ifsc.map(ifsc);
        //  this.IfscState=ifsc.join(" ");

        // this.IfscState= ifsc[0].toUpperCase() + ifsc.slice(1);
      }
      else {
        this.ifsccodedetailsshow = false;
        this.ifsccodedetails = true;
        this.ifsccodedetail = true;

        this.IfscBankName = "";
        this.IfscBranchName = "";
        this.IfscZipCode = "";
        this.IfscCity = "";
        this.IfscAddress = "";
        this.IfscState = "";

      }


    });
  }


  GetUpdateIfsccodedetails() {
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.GetIfsccodedetails(this.BenBankCode.value, merchantdata.MerchantKeyId).subscribe(result => {
      if (result != null) {
        this.updateifsccodedetail = false;
        this.isReadytoUpdateInfo = true;
        this.updateifsccodedetails = false;
        this.updateifsccodedetailsshow = true;

        // this.rows.BeneficiaryName=result.BeneficiaryName;
        this.rows.BranchName = result.BranchName;
        this.rows.BankName = result.BankName;
        this.rows.Address = result.Address;

        this.rows.City = result.City;
        this.rows.State = result.State;
        // this.rows.State=lowerCase;
        // this.IfscState=result.State;
        var ifsc = result.State.toLowerCase().split(' ');
        for (var i = 0; i < ifsc.length; i++) {
          ifsc[i] = ifsc[i].charAt(0).toUpperCase() + ifsc[i].substring(1);
        }
        this.rows.State = ifsc.join(' ');
        this.rows.Address = result.Address;
        this.rows.ZipCode = result.ZipCode;
      }
      else {
        this.updateifsccodedetail = true;
        this.updateifsccodedetailsshow = false;
        this.updateifsccodedetails = true;

        // this.IfscBankName="";
        // this.IfscBranchName="";
        this.rows.BranchName = "";
        this.rows.BankName = "";
        this.rows.Address = "";

        this.rows.City = "";
        this.rows.Address = "";
        this.rows.ZipCode = "";
        this.rows.State = "";

      }


    });
  }



  Getzipcodedetails() {
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.Zipcodedetails(this.ZipCode.value, merchantdata.MerchantKeyId).subscribe(result => {
      if (result != null) {

        this.PCountry = result.Country;
        this.IfscCity = result.CityVillageArea;
        this.IfscState = result.State;
        var pincode = this.IfscState.toLowerCase().split(' ');
        for (var i = 0; i < pincode.length; i++) {
          pincode[i] = pincode[i].charAt(0).toUpperCase() + pincode[i].substring(1);
        }
        this.IfscState = pincode.join(' ');
      }
      else {
        this.PCountry = "";
        this.IfscCity = "";
        this.IfscState = "";
      }
    });
  }


  GetEditzipcodedetails() {
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.Zipcodedetails(this.ZipCode.value, merchantdata.MerchantKeyId).subscribe(result => {
      if (result != null) {

        this.PCountry = result.Country;
        this.IfscCity = result.CityVillageArea;
        this.IfscState = result.State;
        var pincode = this.IfscState.toLowerCase().split(' ');
        for (var i = 0; i < pincode.length; i++) {
          pincode[i] = pincode[i].charAt(0).toUpperCase() + pincode[i].substring(1);
        }
        this.IfscState = pincode.join(' ');
      }
      else {
        this.PCountry = "";
        this.IfscCity = "";
        this.IfscState = "";
      }
    });
  }

}
